// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrap":"AppLoader_spinnerWrap__2ElyM","spinnerBorder":"AppLoader_spinnerBorder__3gzIC","textDark":"AppLoader_textDark__2D9o-"};